// extracted by mini-css-extract-plugin
export default {"placeHolder":"RegionSummaryPage_placeHolder__gAeJN","heading":"RegionSummaryPage_heading__W7-W8","form":"RegionSummaryPage_form__GuQPb"};